import { Box, Typography } from '@mui/material'
import React from 'react'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined'
import AdxButton from 'components/custom/AdxButton'

const StartPage = ({ setStart }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'white.main',
        width: '600px',
        minHeight: 'calc(100vh - 57px)',
        padding: '32px 30px 40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Typography variant="h3" mb={'16px'}>
          Get started
        </Typography>
        <Typography color={'light-gray-text.main'} mb={'32px'}>
          This work personality test consists of several questions.
        </Typography>
        <Box display={'flex'} gap={'20px'} mb={'32px'}>
          <Box>
            <Box
              width={'65px'}
              height={'65px'}
              borderRadius={'100%'}
              bgcolor={'gray-background.main'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <AutoFixHighIcon sx={{ height: '28px', width: '28px', color: 'alternate.main' }} />
            </Box>
          </Box>
          <Box>
            <Typography>Answer truthfully</Typography>
            <Typography color={'light-gray-text.main'}>
              Answer honestly and trust your instincts. There are no right or wrong answers
            </Typography>
          </Box>
        </Box>
        <Box display={'flex'} gap={'20px'} mb={'32px'}>
          <Box>
            <Box
              width={'65px'}
              height={'65px'}
              borderRadius={'100%'}
              bgcolor={'gray-background.main'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <TaskOutlinedIcon sx={{ height: '28px', width: '28px', color: 'alternate.main' }} />
            </Box>
          </Box>
          <Box>
            <Typography>Check your answer before submitting</Typography>
            <Typography color={'light-gray-text.main'}>
              Remember that you can always go back to the previous question and re-affirm your
              answer.
            </Typography>
          </Box>
        </Box>
      </Box>
      <AdxButton variant={'contained'} onClick={() => setStart(true)} sx={{ width: '100%' }}>
        Start now
      </AdxButton>
    </Box>
  )
}

export default StartPage
